import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackTagUpdated } from '../types';

export const useTrackClickedViewAllTagged = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedViewAllTagged = useCallback(
    (params: TrackTagUpdated) => {
      track(`Clicked ViewAllTagged`, params);
    },
    [track],
  );

  return { trackClickedViewAllTagged };
};
